const TRANSITION_SPEED = 450;

class SectionTestimonial extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector(".swiper");
    this.slides = this.querySelectorAll(".swiper-slide");
    this.slides = this.querySelectorAll(".swiper-slide");

    if (!this.viewport || this.slides.length < 2) return;

    window.loadSwiper.then((swiperLib) => this.initSwiper(swiperLib));
  }

  disconnectedCallback() {
    this.swiper?.destroy(true, true);
  }

  initSwiper({ Swiper, EffectFade }) {
    const reducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    this.swiper = new Swiper(this.viewport, {
      modules: [EffectFade],
      slidesPerView: 1,
      speed: reducedMotion ? 0 : TRANSITION_SPEED,
      loop: true,
      effect: "fade",
      fadeEffect: { crossFade: true },
      on: {
        slideChange: () => this.setActiveDot(),
        init: () => this.setActiveDot(),
      },
    });

    this.addEventListener("click", (event) => {
      if (event.target.closest("[data-testimonial-prev]")) {
        this.swiper.slidePrev();
        return;
      }

      if (event.target.closest("[data-testimonial-next]")) {
        this.swiper.slideNext();
        return;
      }

      const dot = event.target.closest("[data-testimonial-dot]");
      if (dot) this.swiper.slideToLoop(Number(dot.dataset.testimonialDot));
    });

    this.setActiveDot();
  }

  setActiveDot() {
    const active = this.swiper?.realIndex ?? 0;

    this.querySelectorAll("[data-testimonial-dot]").forEach((dot) => {
      const isActive = Number(dot.dataset.testimonialDot) === active;
      dot.classList.toggle("is-active", isActive);
      dot.setAttribute("aria-current", isActive ? "true" : "false");
    });

    const activeSlide = this.swiper?.slides[this.swiper.activeIndex];

    this.querySelectorAll(".testimonial__controls").forEach((set) => {
      set.toggleAttribute("inert", set.closest(".swiper-slide") !== activeSlide);
    });
  }
}

if (!customElements.get("section-testimonial")) {
  customElements.define("section-testimonial", SectionTestimonial);
}
